define('SageDotCom/Components/CustomerSuccess/CustomerSuccessListing', [
    "jquery",
    "matchHeight",
    "eventManager",
    "text!SageDotCom/Components/Templates/SpotlightCard.html",
    "SageDotCom/Utility/sageMatchHeight"
], function ($, mh, eventManager, _cardTemplate, SageMatchHeight) {

    function CustomerStoryCollection(scope, storyData, mobileMaximum) {
        Object.defineProperty(this, "scope", { enumerable: true, value: scope, writable: !1 });
        Object.defineProperty(this, "$scope", { enumerable: !0, value: $(scope) });

        var self = this;

        var storyContainer = self.$scope.find(".customer-success-stories");
        var isMobile = storyContainer.hasClass("is-mobile");

        var numberToShow = isMobile ? mobileMaximum : storyData.length;

        var cardTemplateObj = _.template(_cardTemplate);
        var html = "";
        for (var i = 0; i < numberToShow; i++) {
            html += cardTemplateObj(storyData[i]);
        }
        storyContainer.html(html);

        var stories = self.$scope.find(".customer-success-story");

        SageMatchHeight.prototype.applyBinding(stories, true, { byRow: false });
        self._updateItems();

        eventManager.subscribe("spotlight-filter-changed",
            function() {
                self._updateItems();
            });
    };

    CustomerStoryCollection.prototype._updateItems = function() {
        SageMatchHeight.prototype.updateAllHeights();
    }

    CustomerStoryCollection.init = function (args) {
        return new CustomerStoryCollection(args.scope, args.data, args.mobileMaximum);
    };

    return CustomerStoryCollection;
});
define("SageDotCom/Components/Content/CustomerSuccess/CustomerSuccessListing", function(){});

